<template>
  <div
    class="modal-backdrop show"
    :class="{
      fade: fade
    }"
  />
  <div
    class="modal show d-block"
    :class="{
      fade: fade
    }"
  >
    <div
      class="modal-dialog"
      :class="{
        'modal-dialog-centered': centered
      }"
    >
      <div class="modal-content">
        <div class="modal-header">
          <slot name="header" />

          <button
            type="button"
            class="btn-close"
            data-dismiss="modal"
            aria-label="Close"
            v-if="dismissible"
            @click="close"
          />
        </div>

        <div class="modal-body">
          <slot />
        </div>

        <div class="modal-footer">
          <slot name="footer" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BootstrapModal',
  props: {
    dismissible: {
      type: Boolean,
      required: false,
      default: true,
    },
    fade: {
      type: Boolean,
      required: false,
      default: true,
    },
    centered: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  emits: ['closeModal'],
  methods: {
    close() {
      this.$emit('closeModal');
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
